// Note: admin-v2 is configured as a static feature in the store
// due to RTK Query middleware requirements
import { autoRegisterFeature } from '@store/features/factory';

import { adminV2Feature } from './store/feature';

// Auto-register the feature (keeping original name for API compatibility)
autoRegisterFeature(adminV2Feature);

// Export everything
export * from './components';
export * from './store';
export * from './types';
export * from './utils';
export * from './views';
